import React, { useState, useEffect } from "react";
import {
  skipNextCutoff,
  GetSFMDisplay,
  getCutoffSettings,
} from "@helpers/helpers";
import SfmModalStore from "@stores/SfmModalStore";
import Loader from "@components/LoaderComponent/loader";
import Confirmationpopup from "@components/ConfirmationPopup";
import { useTranslation } from "react-i18next";
import BusinessDayHeader from "./BusinessDayHeader";
import BusinessDayCard from "./BusinessDayCard";

const BusinessDayComponent = ({ reloadCutoffData }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [openConfirmationAction, setOpenConfirmationAction] = useState(false);

  const { t: translate } = useTranslation();

  const [data, setData] = useState();

  const getCutOffSetting = () => {
    setIsLoading(true);
    getCutoffSettings((cutOffSettings) => {
      setData(cutOffSettings.CutoffSettings);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    getCutOffSetting();
  }, []);

  // Function to format the date and time
  const formadivate = (dateTime) => {
    const date = new Date(dateTime);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return { formattedDate, formattedTime };
  };

  const skip = () => {
    setIsLoading(true);
    skipNextCutoff((data) => {
      const sfmData = GetSFMDisplay(data.SFM);
      setIsLoading(false);
      SfmModalStore.open(sfmData, () => {
        getCutOffSetting();
      });
    });
  };

  return isLoading ? (
    <Loader dots withContainer />
  ) : (
    <div className="w-[94%] mx-auto flex flex-col my-5 gap-10">
      <BusinessDayHeader
        title={translate("business-day.title")}
        isLoading={isLoading}
        onSkipClick={() => setOpenConfirmationAction(true)}
        translate={translate}
      />
      <div className="flex gap-10 items-center">
        <BusinessDayCard
          title={translate("business-day.business-day")}
          date={data.CurrentBusinessDay}
          instance={data.CurrentBusinessDayInstance}
          cutoffDate={data.CutoffDate}
          formatDateTime={formadivate}
          cutoffLabel={translate("business-day.current-cutoff")}
        />
        <BusinessDayCard
          title={translate("business-day.next-day")}
          date={data.NextBusinessDay}
          instance={data.NextBusinessDayInstance}
          cutoffDate={data.NextCutoffDate}
          formatDateTime={formadivate}
          cutoffLabel={translate("business-day.next-cutoff")}
          cutoffTextSize="text-sm"
        >
          {openConfirmationAction && (
            <Confirmationpopup
              singleAction={{
                actionFN: skip,
                confirmation: true,
                confirmationMessage: translate(
                  "reconciliation-runs.confirmation-messages.SKIP_NEXT_INSTANCE"
                ),
                severity: "high",
              }}
              setOpenConfirmationAction={setOpenConfirmationAction}
            />
          )}
        </BusinessDayCard>
      </div>
    </div>
  );
};

export default BusinessDayComponent;
